module.exports = __webpack_public_path__ + "il.svg?5a12c248e7badb386042c6f20160aef6";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/il.svg
// module id = 1160
// module chunks = 0